
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as callbackitq6do88utFEJ_X7WTMkiwC7H10_45O1t7lrVlxAJSikYMeta } from "/src/pages/auth/callback.vue?macro=true";
import { default as _91_46_46_46id_93MDw9Aj_euROk3PaC0i0uKRaUZRK1c8JG4oGoNXkH1mkMeta } from "/src/pages/ch/com/ofk/[bookId]/[...id].vue?macro=true";
import { default as _91bookId_93QpZMfiUqU8kWuWj__45WibtIScrkeClFmDBvIkdRmX9jwMeta } from "/src/pages/ch/com/ofk/[bookId].vue?macro=true";
import { default as _91_46_46_46canonical_934jIcZJOKNOzqatPrJwB5Jo0TnYIsMwOGyZkn_45SsY_kkMeta } from "/src/pages/ch/rul/[...canonical].vue?macro=true";
import { default as content7SsVi1al_BKO2UwZVlOR49XnMWOovQbfLDFgq9qDp8YMeta } from "/src/pages/content.vue?macro=true";
import { default as helpSYtv9UqGOS1dbH5xEDsPq2idvK0L78hShYRtpKo5yqMMeta } from "/src/pages/help.vue?macro=true";
import { default as indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta } from "/src/pages/index.vue?macro=true";
import { default as login7COOQeYKQwisHoj2xkTxmCi9HyQxCOyTj3KOsyypuxYMeta } from "/src/pages/login.vue?macro=true";
import { default as logoutKcjP9OCArBgqLyfH7yp_45g_IehmoZVZP6H99OCrZ8FhMMeta } from "/src/pages/logout.vue?macro=true";
import { default as confirmzjdO7HPyDhtmjfud1FwR7j3UqTZll07U2IkBHciaByMMeta } from "/src/pages/order/[id]/confirm.vue?macro=true";
import { default as indexkx_hIOJhz9eIHVl8e9BwN9YfOWm4owRV1zg_SwmwelcMeta } from "/src/pages/order/[id]/index.vue?macro=true";
import { default as pricingj0etv4OxJJG_45RONf_U3FY2V1mlza9bSr6Hcj4ZP44PkMeta } from "/src/pages/pricing.vue?macro=true";
import { default as _91url_934RLiaE_Q62U4urB_45o8wv8_45BkwvIRnG1oBxvhjNMrdlcMeta } from "/src/pages/redirect/[url].vue?macro=true";
import { default as _91_91page_93_93lUOlZih5tIUDBC6isJJiM8ETffh9tS4_45vW9Z2EJMPPYMeta } from "/src/pages/search/[[page]].vue?macro=true";
import { default as _91_46_46_46id_93uYlaTgmlYebk8rTEBeBFy1f2qiABfG6oXkp30aIVyvkMeta } from "~/pages/ch/com/ofk/[bookId]/[...id].vue?macro=true";
import { default as _91bookId_93Gn8HVxCEomW3PGMRSRKBHX9cvrvU9W2fTlqHgju4hbIMeta } from "~/pages/ch/com/ofk/[bookId].vue?macro=true";
export default [
  {
    name: "auth-callback",
    path: "/auth/callback",
    component: () => import("/src/pages/auth/callback.vue")
  },
  {
    name: "ch-com-ofk-bookId",
    path: "/ch/com/ofk/:bookId()",
    component: () => import("/src/pages/ch/com/ofk/[bookId].vue"),
    children: [
  {
    name: "ch-com-ofk-bookId-id",
    path: ":id(.*)*",
    component: () => import("/src/pages/ch/com/ofk/[bookId]/[...id].vue")
  }
]
  },
  {
    name: "ch-rul-canonical",
    path: "/ch/rul/:canonical(.*)*",
    component: () => import("/src/pages/ch/rul/[...canonical].vue")
  },
  {
    name: "content",
    path: "/content",
    component: () => import("/src/pages/content.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/src/pages/help.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/src/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/src/pages/logout.vue")
  },
  {
    name: "order-id-confirm",
    path: "/order/:id()/confirm",
    component: () => import("/src/pages/order/[id]/confirm.vue")
  },
  {
    name: "order-id",
    path: "/order/:id()",
    component: () => import("/src/pages/order/[id]/index.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/src/pages/pricing.vue")
  },
  {
    name: "redirect-url",
    path: "/redirect/:url()",
    component: () => import("/src/pages/redirect/[url].vue")
  },
  {
    name: "search-page",
    path: "/search/:page?",
    component: () => import("/src/pages/search/[[page]].vue")
  },
  {
    name: "print-book",
    path: "/print/ch/com/ofk/:bookId",
    meta: {"layout":"print"},
    component: () => import("~/pages/ch/com/ofk/[bookId].vue"),
    children: [
  {
    name: "print-comment",
    path: ":id",
    component: () => import("~/pages/ch/com/ofk/[bookId]/[...id].vue")
  }
]
  }
]